import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

export default function(
  container,
  mapStateToProps,
  mapDispatchToProps,
  options = {},
) {
  let WrappedComponent = options.graphql
    ? options.graphql(container)
    : container
  WrappedComponent = connect(
    mapStateToProps,
    mapDispatchToProps,
  )(WrappedComponent)
  WrappedComponent = withRouter(WrappedComponent)

  class WithPage extends React.Component {
    render() {
      return <WrappedComponent {...this.props} />
    }
  }
  if (typeof window === 'undefined' && container.getInitialProps) {
    WithPage.getInitialProps = container.getInitialProps
  }
  return WithPage
}

export function setCacheMaxAge(res, key, maxAge) {
  res.setHeader('Cache-Control', `no-cache, no-store, must-revalidate`)
  res.setHeader('Surrogate-Control', `max-age=${maxAge}`)
  res.setHeader('Surrogate-Key', key)
  res.setHeader('Pragma', 'no-cache')
  res.setHeader('Expires', '0')
}



// WEBPACK FOOTER //
// ./src/server/withPage.js